import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const images = [
  "/collage1.webp",
  "/collage2.webp",
];

const GalleryCollage = () => {
  return (
    <section
      className="gallery-collage"
      style={{
        backgroundImage: `url(${images[0]})`,
      }}
    >
      <div className="overlay"></div>

      <div className="collage-slider">
        <Swiper
          modules={[Autoplay]}
          slidesPerView={1}
          spaceBetween={30}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
        >
          {images.map((img, index) => (
            <SwiperSlide key={index}>
              <div className="image-card">
                <img src={img} alt={`gallery-${index}`} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default GalleryCollage;
